/**
 * Converts a Blob to a base64 string (without the data URI scheme prefix).
 *
 * @param blob - The Blob to convert
 * @returns Promise<string> - Base64 encoded string
 */
export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        // Remove the data URI scheme prefix (e.g., "data:application/pdf;base64,")
        const base64String = reader.result.split(",")[1];
        if (base64String) {
          resolve(base64String);
          return;
        }
      }
      reject(new Error("Failed to read the Blob as a base64 string."));
    };

    reader.onerror = () => {
      reject(new Error("Unable to read the Blob."));
    };

    reader.readAsDataURL(blob);
  });
};
